import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useRouteMatch } from "react-router";
import { numberFormat } from 'estimate_list/libs/util';
import {encode as base64_encode} from 'base-64';
import jsonp from 'jsonp';
import axios from 'axios';
import { Api } from "estimate_list/libs/api";

const PowerClick = () => {
    const categoryArr = []
    const categoryData = useSelector(state => state.category.categoryData)
    categoryData.map(cate => {
        if(cate.child_count > 0){
            cate.child.map(cate2 => {
                categoryArr[cate2.cate_id] = cate2.cate_keyword
                if(cate2.child_count > 0){
                    cate2.child.map(cate3 => {
                        categoryArr[cate3.cate_id] = cate3.cate_keyword
                        if(cate3.child_count > 0){
                            cate3.child.map(cate4 => {
                                categoryArr[cate4.cate_id] = cate4.cate_keyword
                                if(cate4.child_count > 0){
                                    cate4.child.map(cate5 => {
                                        categoryArr[cate5.cate_id] = cate5.cate_keyword
                                        return null
                                    })
                                }
                                return null
                            })
                        }
                        return null
                    })
                }
                return null
            })
        }
        categoryArr[cate.cate_id] = cate.cate_keyword
        return null
    })
    const [powerClickList, setPowerClickList] = useState([])
    const [adCompany, setAdCompany] = useState()
    const match = useRouteMatch()
    const [marketImage, setmarketImage] = useState()
    const [marketImageClass, setMarketImageClass] = useState()
    const categoryKey = match.params.categoryID ? match.params.categoryID : '1010100000'
    let keyword = categoryArr[categoryKey]
    let host = 'www.pping.kr'
    const maxcount = 6
    const media = 'pping'
    const ch = 'pping_pc_srp_top'
    const adult_img = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_adult.jpg`
    const jsonpFlag = useRef(null)
    jsonpFlag.current = true
    const coupangList = useRef(null)

    const handleGetAdLogo = (idx_b_manger) => {
        Api.getMarketLogo(idx_b_manger, 'ad').then((res) => {
            const { adDesktopLogo } = res?.data?.result
            setmarketImage(adDesktopLogo)
        })
    }

    const handleSetAdList = (logoNumber, marketName, resultList) => {
        handleGetAdLogo(logoNumber)
        setAdCompany(marketName)
        setPowerClickList(resultList)
        setMarketImageClass(`${marketName}Image`)
    }

    const apiCall = useCallback(async () => {
        //쿠팡
        const param2 = 'company_uid=91DA6CADDF9E4813AE8F61B553A4E7CA&cp_keyword='+encodeURI(keyword)+'&cp_count=6'
        let _url2 = 'https://ad.planbplus.co.kr/web_api/pping_search/?' + param2

        // 20211124 SYC : 쿠팡 undefined 호출 제거
        if (keyword !== undefined) {
            axios.get(_url2).then((res) => {
                coupangList.current = res.data.data
            })
        }
        //이베이
        const params = 'host=' + host + '&maxcount=' + maxcount + '&thumb_label=' + unescape(encodeURIComponent(keyword)) +'&media=' + media + '&ch=' + ch + '&ref='
        let _url = 'https://powerclick.about.co.kr/pclick/jsonp?' + base64_encode(params)

        jsonp(_url, {name:'callback'}, (error, res) => {
            if (error) {
                console.log(error)
            } else {
                // 0 : 옥션, 1 : 지마켓, 2 : 쿠팡
                const AdListLength = [
                    {name : 'auction', adCount : (res.market.auction) ? res.market.auction : 0},
                    {name : 'gmarket', adCount : (res.market.gmarket) ? res.market.gmarket : 0},
                    {name : 'coupang', adCount : (coupangList.current) ? coupangList.current.length : 0},
                ]
                //정렬
                AdListLength.sort(function(a, b) {
                    return b.adCount - a.adCount;
                })

                const AdRandomList = [AdListLength[0]]
                for (let i = 1; i < AdListLength.length; i++){
                    if(AdListLength[0].adCount === AdListLength[i].adCount) AdRandomList[i] = AdListLength[i]
                }

                let randomNum = Math.round(Math.random() * (AdRandomList.length - 1))
                let AdList = AdRandomList[randomNum]

                if (res.ad_result === 0 && (!coupangList.current || coupangList.current.length === 0)){
                    setPowerClickList([])
                    jsonpFlag.current = false
                } else{
                    if (AdList.name === 'auction'){
                        const resultList = res.creatives.auction
                        const logoNumber = 41
                        handleSetAdList(logoNumber, 'auction', resultList)
                    } else if (AdList.name === 'gmarket'){
                        const resultList = res.creatives.gmarket
                        const logoNumber = 35
                        handleSetAdList(logoNumber, 'gmarket', resultList)
                    } else if (AdList.name === 'coupang'){
                        const resultList = coupangList.current
                        const logoNumber = 8984
                        handleSetAdList(logoNumber, 'coupang', resultList)
                    }
                }
            }
        })
    }, [keyword, host]);

    useEffect(() => {
        apiCall();
    }, [keyword, apiCall])

    return (
        <div>
            {powerClickList.length !== 0 ? (
                <Case>
                    <div className='powerCLickTitle'>
                        <span className='adTitle'>오픈쇼핑 </span>
                        <span className='adSpan'>광고</span>
                        <span className='adDetail'> 광고상품입니다. 실제 구매가격은 할인율, 옵션 선택에 따라 달라질 수 있습니다.</span>
                    </div>
                    {adCompany === 'coupang' ? '' : <a className='adSubscript' href="https://ad.esmplus.com" target='_blank' rel="noopener noreferrer">광고신청 &gt;</a>}
                    <div className='powerClickList'>
                        <ul>
                            {powerClickList.length !== 0 && powerClickList?.slice(0,6).map((v, i) => {
                                if (adCompany === 'auction' || adCompany === 'gmarket') axios.get(v.imp_t)
                                return (
                                    <li key={i}>
                                        <a href={adCompany === 'coupang' ? v.landingUrl : v.landing} target='_blank' rel='noopener noreferrer' className='powerClickImageA'>
                                            {adCompany === 'coupang' ? <img alt='상품이미지' src={v.productImage} className='powerClickImage'/> : <img alt='상품이미지' src={v.is_adult ? adult_img : v.imgL} className='powerClickImage'/>}
                                                <p className='powerClickTitleP'>{adCompany === 'coupang' ? v.productName : v.title}</p>
                                                    <p className='marketImageP'>
                                                        <img alt='마켓이미지' src={marketImage} className={marketImageClass}/>
                                                            <span className='marketPrice'>{adCompany === 'coupang' ? numberFormat(v.productPrice) : numberFormat(v.sale_price)}원</span>
                                                    </p>
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </Case>
            ) : ('')}
        </div>
    );
}
const Case = styled.div`
    min-height:264px;
    border:1px solid #c8c8c8;
    margin-top:10px;
    margin-bottom: 10px;

    & > .adSubscript {
        float: right;
        padding: 2px 8px 1px 8px !important;
        border: 1px solid #c8c8c8;
        font-size: 11px;
        line-height: 14px;
        margin-top: 10px;
        margin-right: 10px;

        &:hover {
            text-decoration: underline
        }
    }

    & > .powerCLickTitle {
        font-weight: bold;
        margin-top:10px;
        margin-left:10px;
        display:inline-block;
        font-size: 18px;
    }

    & > .powerCLickTitle > .adSpan {
        font-weight : bold;
        padding: 2px 8px 1px 8px !important;
        border: 1px solid #c8c8c8;
        font-size: 11px;
        line-height: 14px;
    }

    & > .powerCLickTitle > .adDetail {
        font-weight : normal;
        font-size: 12px;
    }

    & > .powerClickList {
        margin-top : 10px;
    }

    & > .powerClickList > ul > li {
        width : 132px;
        float : left;
        margin-left : 23px;
    }

    & > .powerClickList > ul > li > .powerClickImageA > .powerClickImage {
        width : 132px;
        height : 132px;
    }

    & > .powerClickList > ul > li > a > .powerClickTitleP {
        height: 35px;
        overflow: hidden;
        margin-top: 10px;

        &:hover {
            text-decoration: underline
        }
    }

    & > .powerClickList > ul > li > a > .marketImageP {
        margin-top: 10px;
    }

    & > .powerClickList > ul > li > a > .marketImageP > .gmarketImage {
        vertical-align: middle;
        margin-bottom: 2px;
    }

    & > .powerClickList > ul > li > a > .marketImageP > .auctionImage {
        margin-top: 1px;
        margin-right: 5px;
        vertical-align: middle;
    }

    & > .powerClickList > ul > li > a > .marketImageP > .marketPrice{
        color: blue;
        vertical-align: middle;
    }
`
export default PowerClick



// WEBPACK FOOTER //
// ./src/estimate_list/components/powerClick/index.js